import React from 'react'
import { Link } from 'react-router-dom';
import { FiArrowRightCircle } from "react-icons/fi";

export const Header = () => {
    return (
		<header className="main-header header-three fixed-header">
			<div className="header-upper">
				<div className="container clearfix">
					<div className="header-inner py-20">
						<div className="logo-outer">
							<div className="logo">
								{/* <span className='text-head-portal'>Dinas Pendidikan</span> */}
							</div>
						</div>
						<div className="menu-right d-none d-lg-flex align-items-center margin-portal">
							<Link to={'/home'} className="login">Masuk Website <FiArrowRightCircle className='portal-head-icon' /></Link>
						</div>
					</div>
				</div>
			</div>
		</header>
    )
};